"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddProductError = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const AddProductError = (param)=>{
    let { errorMessage } = param;
    if (errorMessage) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
            children: errorMessage
        });
    }
    return null;
};
exports.AddProductError = AddProductError;
